import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CalleDeBruto {
  getCallesDeBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`calle_de_bruto?r=` +
        `{"orden":["nombre"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default CalleDeBruto
